import { useContext, useEffect } from 'react';
import FormContext from './formContext';
function useField(name, value) {
    const formContext = useContext(FormContext);
    useEffect(() => {
        if (!formContext) {
            return;
        }
        const unsubscribe = formContext.subscribe(() => {
            formContext.collect(name, value);
        });
        return unsubscribe;
    }, [name, value]);
}
export default useField;
